import {
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowUp,
} from "@mui/icons-material";
import { Box, Collapse, Typography } from "@mui/material";
import { useState } from "react";

export function MLocationSection({ handleClose }: { handleClose: () => void }) {
  const [seeMore, setSeeMore] = useState(false);
  const handleOnClick = (e: any) => {
    const prev = seeMore;
    setSeeMore(!prev);
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        bgcolor="#af9b65"
        py={2}
      >
        <Box
          display="flex"
          alignItems="center"
          onClick={handleClose}
          color="white"
          position="absolute"
          left={10}
          top="50%"
          sx={{ transform: "translateY(-50%)" }}
        >
          <KeyboardArrowLeft />
          <Typography fontWeight="bold">戻る</Typography>
        </Box>
        <Typography color="white" variant="h6" fontWeight="bold">
          アクセス
        </Typography>
      </Box>
      <Box display="flex" flex={1} width="100%" position="relative">
        <Box
          height="100%"
          component="img"
          src="/images/store-detail/map1.png"
        />
        <Box position="absolute" top={0} right={0} left={0} bgcolor="white">
          <Typography sx={{ p: 1 }}>
            東京都中央区銀座4-6-16　銀座三越12F
          </Typography>
          <Box
            display="flex"
            p={1}
            onClick={handleOnClick}
            borderTop={1}
            borderColor="divider"
          >
            <Typography fontWeight='bold' sx={{ display: "flex", flex: 1 }}>
              レストランへの行き方
            </Typography>
            {seeMore ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </Box>
          <Collapse in={seeMore} sx={{p: 1}}>
            <Typography>東京メトロ 線　銀座駅　A7出口を出てすぐ「銀座三越」の12階です。</Typography>
            <Typography>東京メトロ線　銀座一丁目駅　9番出口より徒歩5分 </Typography>
            <Typography>都営浅草線　東銀座駅　銀座駅方面地下通路経由徒歩2分</Typography>
            <Typography>JR線　有楽町駅　徒歩9分</Typography>
          </Collapse>
        </Box>
      </Box>
    </Box>
  );
}
